import OperatorAvatar from '../OperatorAvatar'
import styles from './styles.module.scss'

function OperatorAvatarWithName({ operatorName, operatorAvatar, isAiBotMsg }) {
  return (
    <div className={styles.operator_avatar_container}>
      <span className={styles.operator_avatar_container__name}>{operatorName}</span>
      <OperatorAvatar size={30} name={operatorName} avatarUrl={operatorAvatar} isBotAvatar={isAiBotMsg} />
    </div>
  )
}

export default OperatorAvatarWithName
